import { AiClient, IntroductionGenerationPayload } from 'api/clients/AiClient'
import { pipe } from 'lodash/fp'

export const generateIntroduction = async ({
  payload,
  signal,
}: {
  payload: IntroductionGenerationPayload
  signal?: AbortSignal
}) => {
  const introductionResponse = await AiClient.generateIntroduction({ payload, signal })

  return sanitise({ str: introductionResponse || '', payload }).str
}

const sanitise = (args: { str: string; payload: IntroductionGenerationPayload }) =>
  pipe(trimEmptyLinesAtBeginning, removeTitle, trimEmptyLinesAtBeginning, trimEmptyLinesAtEnd)(args)

type SanitiseFn = (args: { str: string; payload: IntroductionGenerationPayload }) => {
  str: string
  payload: IntroductionGenerationPayload
}
const removeTitle: SanitiseFn = ({ str, payload }) => {
  if (!str.startsWith(payload.title)) {
    return { str, payload }
  }
  return { str: str.slice(payload.title.length), payload }
}
const trimEmptyLinesAtBeginning: SanitiseFn = ({ str, payload }) => ({ str: str.replace(/^\s*[\r\n]/, ''), payload })
const trimEmptyLinesAtEnd: SanitiseFn = ({ str, payload }) => ({ str: str.replace(/[\r\n]\s*$/, ''), payload })
